/* eslint-disable react/no-multi-comp */
import React, { useEffect } from 'react'
import { bool, element, func, object, oneOfType, string } from 'prop-types'
import { useGlobal } from '../../contexts/GlobalContext'
import { navigateParaHome } from '../../utils/rotas/navigate'
import { getInformacoesModalidadePorAssinatura, getModalidadePelaURL, getMetodoPagamentoModalidadePelaURL } from '../../utils/helpers/helpersAssinatura'
import { resolverCategorias, temBookster } from '../../utils/helpers/helpersToken'
import { METODO_PAGAMENTO_CARTAO, URLS, URLS_BOLETO } from '../../constants'
import { isEmptyObject } from '../../utils/helpers/helpers'

function LazyComponent( { Component, Context, Element, currentRoute, isRotaProtegida, requerBookster, location, ...props } ) {
  const {
    dadosGlobaisAssociado,
    fazLogout,
    isAssociadoLogado,
    modalidadesDaAssinatura,
    setRotaAtual,
  } = useGlobal()

  useEffect( () => {
    if ( currentRoute ) {
      setRotaAtual( currentRoute )
    }
  }, [ currentRoute ] )

  useEffect( () => {
    let cancelado = false

    const verificarAcesso = async() => {
      const categorias = await resolverCategorias()
      if ( !cancelado && !temBookster( categorias ) ) {
        navigateParaHome()
      }
    }

    if ( requerBookster && isAssociadoLogado ) {
      verificarAcesso()
    }

    return () => {
      cancelado = true
    }
  }, [ requerBookster, isAssociadoLogado ] )

  useEffect( () => {
    // Bookster não usa o conceito de "modalidade" (Curadoria/Inéditos);
    // o gate requerBookster acima já cobre autorização.
    if ( requerBookster ) {
      return
    }
    if ( location && modalidadesDaAssinatura && modalidadesDaAssinatura.length ) {
      const { pathname } = location
      const pathModalidade = pathname.split( URLS.HOME )
      const modalidade = getModalidadePelaURL( pathModalidade[ 1 ], modalidadesDaAssinatura )
      const infoModalidadePathName = pathModalidade.length && pathModalidade[ 1 ] && getInformacoesModalidadePorAssinatura( pathModalidade[ 1 ] )
      const objetoModalidade = !isEmptyObject( infoModalidadePathName ) && infoModalidadePathName.visualizacao
      if ( !modalidade && infoModalidadePathName && !modalidadesDaAssinatura.includes( objetoModalidade ) ) {
        navigateParaHome()
      } else if ( dadosGlobaisAssociado && modalidade ) {
        const metodoPagamento = getMetodoPagamentoModalidadePelaURL( dadosGlobaisAssociado.assinaturas, modalidade )
        if ( metodoPagamento === METODO_PAGAMENTO_CARTAO.visualizacao && URLS_BOLETO.includes( pathModalidade[ 4 ] ) ) {
          navigateParaHome()
        }
      }
    }
  }, [ location, modalidadesDaAssinatura, dadosGlobaisAssociado, requerBookster ] )

  useEffect( () => {
    if ( isRotaProtegida && !isAssociadoLogado ) {
      const urlPaths = location && location.pathname.split( '/' )
      if ( urlPaths?.length >= 1 && urlPaths[ urlPaths.length -1 ] !== 'login' ) {
        const queryString = new URLSearchParams( location.search )
        const redirectTo = queryString.get( 'redirectTo' )
        const coupon = queryString.get( 'cupom' )
        fazLogout( { 'redirectTo': redirectTo ? redirectTo : location.pathname, coupon } )
      }
    }
  }, [ isAssociadoLogado, isRotaProtegida ] )

  const content = () => {
    if ( Component ) {
      return (
        <Component
          location={ location }
          { ...props }
        />
      )
    }

    if ( Element ) {
      return React.cloneElement( Element, { ...props, location } )
    }

    return null
  }

  return (
    Context ? (
      <Context>
        { content() }
      </Context>
    ) : content()
  )
}

LazyComponent.defaultProps = {
  'Component': null,
  'Context': null,
  'Element': null,
  'currentRoute': null,
  'isRotaProtegida': true,
  'requerBookster': false,
  'location': null
}

LazyComponent.propTypes = {
  'Component': oneOfType( [ func, object ] ),
  'Context': oneOfType( [ func, element ] ),
  'Element': oneOfType( [ func, element ] ),
  'currentRoute': string,
  'isRotaProtegida': bool,
  'requerBookster': bool,
  'location': object
}

export default LazyComponent
